import { useEffect, useState } from 'react';
import { authFetch } from '../../auth/authFetch';
import { getApiBaseUrl } from '../../auth/api';
import { Button, Card } from '@humanforce/mango-ui-react';
import { PageTitle } from '../../components/layout/PageTitle';

const API_BASE = getApiBaseUrl();

interface ConnectivityResult {
  tenantSlug: string;
  database: string;
  dbTimestamp: string;
  dbVersion: string;
  apiTimestamp: string;
  status: string;
  error?: string;
}

const ConnectivityCard = () => {
  const [result, setResult] = useState<ConnectivityResult | null>(null);
  const [loading, setLoading] = useState(false);

  const checkConnectivity = async () => {
    setLoading(true);
    try {
      const res = await authFetch(`${API_BASE}/Connectivity`);
      const data = await res.json() as ConnectivityResult;
      setResult(data);
    } catch (error) {
      setResult({ status: 'disconnected', error: String(error), tenantSlug: '', database: '', dbTimestamp: '', dbVersion: '', apiTimestamp: '' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void checkConnectivity();
  }, []);

  const statusDotStyle = {
    display: 'inline-block',
    width: 'var(--mgo-size-20)',
    height: 'var(--mgo-size-20)',
    borderRadius: 'var(--mgo-radius-rounded)',
    background: result?.status === 'connected' ? 'var(--mgo-color-bg-positive)' : 'var(--mgo-color-bg-critical)',
  };

  return (
    <Card header="Database Connectivity" footer={<Button variant="secondary" onClick={() => void checkConnectivity()}>Refresh</Button>}>
      {loading && <p>Checking...</p>}
      {result?.status === 'connected' && (
        <div className="mgo-stack mgo-gap-m">
          <div className="mgo-cluster mgo-gap-s">
            <span style={statusDotStyle} />
            <p style={{ margin: 0 }}><strong>Connected</strong> - UI to API to Tenant DB</p>
          </div>
          <p className="mgo-text-s mgo-color-muted" style={{ margin: 0 }}>Tenant: {result.tenantSlug} - DB: {result.database}</p>
          <p className="mgo-text-s mgo-color-muted" style={{ margin: 0 }}>DB Time: {new Date(result.dbTimestamp).toLocaleString()}</p>
          <p className="mgo-text-s mgo-color-muted" style={{ margin: 0 }}>DB Version: {result.dbVersion}</p>
          <p className="mgo-text-s mgo-color-muted" style={{ margin: 0 }}>API Time: {new Date(result.apiTimestamp).toLocaleString()}</p>
        </div>
      )}
      {result?.status === 'disconnected' && (
        <div className="mgo-cluster mgo-gap-s">
          <span style={statusDotStyle} />
          <p style={{ margin: 0 }}><strong>Disconnected</strong> - {result.error}</p>
        </div>
      )}
    </Card>
  );
};

const DashboardPage = () => {
  return (
    <>
      <PageTitle title="Dashboard" />
      <ConnectivityCard />
    </>
  );
};

export default DashboardPage;
